import { render, staticRenderFns } from "./barsVehiculos.vue?vue&type=template&id=392143b9"
import script from "./barsVehiculos.vue?vue&type=script&lang=js"
export * from "./barsVehiculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports